module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.seller.avatar,
      "width": "64",
      "height": "64"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "brand"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.seller.name))])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        " + _vm._s(_vm.seller.description + ' / ' + _vm.seller.deliveryTime + '分钟送达') + "\n      ")]), _vm._v(" "), (_vm.seller.supports) ? _c('div', {
    staticClass: "supports"
  }, [_c('div', {
    staticClass: "supports_desc"
  }, [_c('support-icon', {
    staticClass: "icon",
    attrs: {
      "supportType": _vm.seller.supports[0].type,
      "iconType": 1
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.seller.supports[0].description))])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.seller.supports) ? _c('div', {
    staticClass: "support-count",
    on: {
      "click": _vm.toggleSellerDetails
    }
  }, [_c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.seller.supports.length + '个'))]), _vm._v(" "), _c('i', {
    staticClass: "icon-keyboard_arrow_right"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bulletin-wrapper",
    on: {
      "click": _vm.toggleSellerDetails
    }
  }, [_c('span', {
    staticClass: "bulletin-title"
  }), _vm._v(" "), _c('span', {
    staticClass: "bulletin-text"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))]), _vm._v(" "), _c('i', {
    staticClass: "icon-keyboard_arrow_right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "background"
  }, [_c('img', {
    attrs: {
      "src": _vm.seller.avatar,
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('seller-details', {
    ref: "sellerDetails",
    attrs: {
      "seller": _vm.seller
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65e1e982"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Header.vue
// module id = 240
// module chunks = 1